import type { TreeCursor } from '@lezer/common';

import { getTextFromRange } from './get-text.js';

/** @internal */
export function getStatementStatus(
  statementCursor: TreeCursor,
  doc?: string,
): 'complete' | 'incomplete' | 'indeterminate' {
  let hasKey = false;
  let hasOperator = false;
  let hasValue = false;
  let key = '';

  const { to } = statementCursor.node;

  statementCursor.iterate((childNode) => {
    // TODO: remove once the lezer bugfix is released and our dependency updated.
    // The 'iterate' doc says 'Iterate over the current node and all its descendants', but it
    // continues also with siblings... This is to stop iterating once we leave the filter statement.
    if (childNode.from >= to) {
      return false;
    }

    switch (childNode.name) {
      case 'FilterKey':
      case 'FreeText':
        hasKey = true;

        if (doc) {
          key = getTextFromRange(childNode, doc.toString());
        }
        break;
      case 'ComparisonOperator':
      case 'InclusionOperator':
        hasOperator = true;
        break;
      case 'SearchOperator':
        hasKey = true;
        hasOperator = true;
        break;
      case 'ExistsOperator':
        hasOperator = true;
        hasValue = true;
        break;
      case 'FilterSimpleValue':
      case 'FilterIncludesValue':
        hasValue = true;
        break;
      case 'InvalidIdentifier':
        hasValue = false;
        break;
    }
  });

  if (hasKey && hasOperator && hasValue) {
    return 'complete';
  }

  // If the statement only has a key and it is 'o' / 'a' / 'an', we don't know if it is an
  // OR / AND operator or an unfinished key so we consider it indeterminate.
  if (!hasOperator && !hasValue && hasKey) {
    const lowerCaseKey = key.toLowerCase();
    return lowerCaseKey === 'o' || lowerCaseKey === 'a' || lowerCaseKey === 'an'
      ? 'indeterminate'
      : 'incomplete';
  }

  return 'incomplete';
}
